export const asyncComponentsUrl = import.meta.env.VITE_ASYNC_COMPONENTS_URL;
export const stylesUrl = import.meta.env.DEV ? asyncComponentsUrl.replace(/^\.\.\//, '') : asyncComponentsUrl;

let hashCache: Record<string, string> | null = null;
export const getHashMap = async () => {
    if (hashCache) return hashCache;
    const { default: hashMaps } = await import(/* @vite-ignore */ `${asyncComponentsUrl}hash-map.js`);
    hashCache = hashMaps;
    return hashMaps;
};

const cache = new Map<string, unknown>();
// Generic to allow caller to specify expected module shape.
export const getDynamicImport = async <T = unknown>(key: string): Promise<T> => {
    if (cache.has(key)) {
        return cache.get(key) as T;
    }
    const hashMaps = await getHashMap();
    const hashedFileName = hashMaps[key];
    // isDev to fix a small quirk with loading css and js in local, since css cannot be imported in prod as done here.
    // see `Import the built css for the cdn components` in main.ts
    const result = await import(/* @vite-ignore */ `${asyncComponentsUrl}${hashedFileName}`);
    cache.set(key, result as unknown);
    return result as T;
};